import { useState, useEffect } from "react";
import { Activity, Menu, X } from "lucide-react";
import { Button } from "../ui/button";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Funcionalidades", href: "#features" },
    { label: "Como funciona", href: "#how-it-works" },
    { label: "Precios", href: "#pricing" },
    { label: "Testimonios", href: "#testimonials" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <>
      <nav
        data-testid="navbar"
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
          scrolled ? "nav-scrolled shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <a
              href="#"
              data-testid="navbar-logo"
              className="flex items-center gap-2.5 group"
            >
              <div className="w-9 h-9 bg-emerald-500 rounded-xl flex items-center justify-center transform group-hover:rotate-6 transition-transform duration-300">
                <Activity className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading font-bold text-xl text-slate-800 tracking-tight">
                fisiotherapy
                <span className="text-emerald-500">.app</span>
              </span>
            </a>

            {/* Desktop Links */}
            <div className="hidden lg:flex items-center gap-1">
              {links.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-emerald-600 rounded-lg hover:bg-emerald-50/60 transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </div>

            {/* Desktop CTA */}
            <div className="hidden lg:flex items-center gap-3">
              <a
                href="#"
                data-testid="navbar-login-btn"
                className="text-sm font-medium text-slate-600 hover:text-emerald-600 px-4 py-2 transition-colors duration-200"
              >
                Iniciar sesion
              </a>
              <Button
                data-testid="navbar-cta-btn"
                className="bg-emerald-500 hover:bg-emerald-600 text-white font-medium px-6 py-2.5 rounded-full shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30 transition-shadow duration-200"
              >
                Prueba gratis
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              data-testid="navbar-mobile-toggle"
              className="lg:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition-colors duration-200"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-40 mobile-menu-overlay lg:hidden"
          onClick={() => setMobileOpen(false)}
        >
          <div
            className="absolute top-16 left-0 right-0 bg-white border-b border-slate-200 shadow-xl p-4 space-y-1"
            onClick={(e) => e.stopPropagation()}
          >
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="block px-4 py-3 text-sm font-medium text-slate-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors duration-200"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <div className="pt-3 border-t border-slate-100 flex flex-col gap-2">
              <a
                href="#"
                className="block px-4 py-3 text-sm font-medium text-slate-600 text-center"
              >
                Iniciar sesion
              </a>
              <Button
                data-testid="navbar-mobile-cta"
                className="w-full bg-emerald-500 hover:bg-emerald-600 text-white font-medium rounded-full"
              >
                Prueba gratis
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
